import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerServiceWorker } from './pwa';
import { installNativeFilePicker } from './services/nativeFilePicker';

registerServiceWorker();
installNativeFilePicker();

// Recover from WKWebView content process termination (iOS file picker memory pressure)
let lastVisibleTime = Date.now();
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    lastVisibleTime = Date.now();
  } else if (document.visibilityState === 'visible') {
    const rootEl = document.getElementById('root');
    const elapsed = Date.now() - lastVisibleTime;
    if (elapsed > 500 && rootEl && !rootEl.hasChildNodes()) {
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);




